export const tableTheme = {
  baseStyle: {
    th: {
      textTransform: "none",
    },
  },
};
